function applyHeadSettings(title, lang) {
  if (title !== void 0) document.title = title || "";
  if (lang !== void 0) document.documentElement.lang = lang || "en";
}
export {
  applyHeadSettings as a
};
//# sourceMappingURL=applyHeadSettings-B0wJc4FV.js.map
